(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["localization-selector"] && !Shopify.designMode) return;
  try {
    window.Shopify = window.Shopify || {};
  window.zag = window.zag || {};

  window.zag.components.LocalizationSelector = class extends window.zag.components.ZagComponent {
    constructor() {
      super();
    }

    connectedCallback() {
      if (this.localizationPopin) {
        this.events.add(this, 'click', this.onClick);
      }
    }

    get localizationPopin() {
      return this.cache.get('dom', 'localizationPopin', () => {
        return document.querySelector('zag-localization');
      });
    }

    onClick() {
      this.localizationPopin.show();
    }
  };
  if (!window.customElements.get('localization-selector')) {
    window.customElements.define('localization-selector', window.zag.components.LocalizationSelector);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    window.Shopify = window.Shopify || {};
  window.zag = window.zag || {};

  window.zag.components.ZagProductCard = class extends window.zag.components.ZagComponent {
    connectedCallback() {
      this.colorSwatches.forEach((swatch) => {
        this.events.add(swatch, 'click', this.onColorSwatchClick);
      });
    }

    get featuredImage() {
      return this.cache.get('dom', 'featuredImage', () => {
        return this.querySelector('.featured-image');
      });
    }

    get colorImages() {
      return this.cache.get('dom', 'colorImages', () => {
        return Array.from(this.querySelectorAll('.color-image'));
      });
    }

    get colorSwatches() {
      return this.cache.get('dom', 'colorSwatches', () => {
        return Array.from(this.querySelectorAll('.color-swatch'));
      });
    }

    onColorSwatchClick = (event) => {
      event.preventDefault();

      const swatch = event.currentTarget;
      if (swatch.getAttribute('aria-current') === 'true') return;

      const color = swatch.dataset.color;

      this.colorSwatches.forEach((colorSwatch) => {
        colorSwatch === swatch
          ? colorSwatch.setAttribute('aria-current', 'true')
          : colorSwatch.setAttribute('aria-current', 'false');
      });

      const colorImage = this.querySelector(`.media-container-card [data-color="${color}"]`);
      if (!colorImage) {
        this.featuredImage.removeAttribute('aria-hidden');
        this.colorImages.forEach((image) => {
          image.setAttribute('aria-hidden', 'true');
        });
      } else {
        this.featuredImage.setAttribute('aria-hidden', 'true');
        this.colorImages.forEach((image) => {
          image === colorImage ? image.removeAttribute('aria-hidden') : image.setAttribute('aria-hidden', 'true');
        });
      }

      console.log('colorImage', colorImage);
      console.log('this.featuredImage', this.featuredImage);
      console.log('this.colorImages', this.colorImages);
      console.log('this.colorSwatches', this.colorSwatches);
    };
  };
  window.customElements.define('zag-product-card', window.zag.components.ZagProductCard);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-price"] && !Shopify.designMode) return;
  try {
    window.Shopify = window.Shopify || {};
  window.zag = window.zag || {};

  window.zag.components.ZagPrice = class extends window.zag.components.ZagComponent {
    constructor() {
      super();
    }

    get locale() {
      return this.cache.get('shop', 'locale', () => {
        return window.Shopify.locale || 'fr';
      });
    }

    get country() {
      return this.cache.get('shop', 'country', () => {
        return window.Shopify.country || 'FR';
      });
    }

    get currency() {
      return this.cache.get('shop', 'currency', () => {
        return window.Shopify.currency.active || 'EUR';
      });
    }

    renderPrice = (price, compareAtPrice) => {
      const priceInUnits = parseFloat(price / 100);
      const compareAtPriceInUnits = compareAtPrice ? parseFloat(compareAtPrice / 100) : 0;

      if (
        this.modifiers.has('no-compare-at-price') ||
        !compareAtPriceInUnits ||
        compareAtPriceInUnits <= priceInUnits
      ) {
        this.innerHTML = this.formatPrice(priceInUnits);
        return;
      }

      this.modifiers.remove('no-compare-at-price');
      this.innerHTML = `<span>${this.formatPrice(compareAtPriceInUnits)}</span>${this.formatPrice(priceInUnits)}`;
    };

    formatPrice = (price, hideDecimals = true) => {
      const isWholeNumber = price % 1 === 0;
      const shouldHideDecimals = hideDecimals && isWholeNumber;

      const formatter = new Intl.NumberFormat(`${this.locale}-${this.country}`, {
        style: 'currency',
        currency: this.currency,
        maximumFractionDigits: shouldHideDecimals ? 0 : 2,
      });
      return formatter.format(price);
    };
  };
  if (!window.customElements.get('zag-price')) {
    window.customElements.define('zag-price', window.zag.components.ZagPrice);
  }
  } catch(e) { console.error(e); }
})();

})();
